import { Account } from '@/client/accounts';
import { SendingProfileType } from '@/client/sender-profiles';
import { EMAIL_REGEX, USERNAME_REGEX } from '@/common/constants';
import { TranslationFunctionType } from '@/common/types';
import { boolean, object, string } from 'yup';

export const createSenderProfileSchema = (
  t: TranslationFunctionType,
  account?: Account | null,
) =>
  object({
    name: string().required(t('error.requiredField')),
    senderName: string().nullable(),
    fromAddress: string()
      .required(t('error.requiredField'))
      .matches(EMAIL_REGEX, t('error.invalidEmail')),
    interfaceType: string().required(t('error.requiredField')),
    host: string()
      .required(t('error.requiredField'))
      .test('host-validation', function (value) {
        if (!value) return true;

        const useMailConnector =
          account?.sendingProfileType === SendingProfileType.CONNECTOR;
        const containsHeysender = value.toLowerCase().includes('heysender');

        if (useMailConnector && containsHeysender) {
          return this.createError({
            message: t('sender.error.hostNotAllowed'),
          });
        }

        return true;
      }),
    username: string()
      .nullable()
      .matches(USERNAME_REGEX, t('error.onlyLetters')),
    password: string().nullable(),
    ignoreCertErrors: boolean(),
  });

export const updateSenderProfileSchema = (
  t: TranslationFunctionType,
  account?: Account | null,
) =>
  object({
    name: string().required(t('error.requiredField')),
    senderName: string().nullable(),
    fromAddress: string()
      .required(t('error.requiredField'))
      .matches(EMAIL_REGEX, t('error.invalidEmail')),
    interfaceType: string().required(t('error.requiredField')),
    host: string()
      .required(t('error.requiredField'))
      .test('host-validation', function (value) {
        if (!value) return true;

        const useMailConnector =
          account?.sendingProfileType === SendingProfileType.CONNECTOR;
        const containsHeysender = value.toLowerCase().includes('heysender');

        if (useMailConnector && containsHeysender) {
          return this.createError({
            message: t('sender.error.hostNotAllowed'),
          });
        }

        return true;
      }),
    username: string()
      .nullable()
      .matches(USERNAME_REGEX, t('error.onlyLetters')),
    password: string().nullable(),
    ignoreCertErrors: boolean(),
  });
